/**
 * 履歴の差分の値を画面表示用の文字列にする (マスタ変更履歴 SBI 7)。
 *
 * 値の型はマスタごとに違う (文字列・数値・真偽値・配列・オブジェクト・null)。
 * 空と「値なし」を区別して表示し、構造のある値は整形した JSON にする。
 * 文字単位の差分 (強調表示) はここでは行わない。
 */

export const VALUE_NONE_LABEL = '(なし)';
export const VALUE_EMPTY_LABEL = '(空)';

export function formatChangeValue(value: unknown): string {
  if (value === null || value === undefined) return VALUE_NONE_LABEL;
  if (typeof value === 'string') return value === '' ? VALUE_EMPTY_LABEL : value;
  if (typeof value === 'boolean') return value ? 'はい' : 'いいえ';
  if (typeof value === 'number' || typeof value === 'bigint') return String(value);
  try {
    return JSON.stringify(value, null, 2) ?? String(value);
  } catch {
    // 循環参照など。API の JSON からは起きない想定だが、画面が落ちないようにする。
    return String(value);
  }
}
